document.addEventListener("DOMContentLoaded", function () {
  if (isWhereToBuyPage()) {
    handleLogoClickOnWhereToBuyPage();
    setupSTPTAfterLocationsUpdate();
  }

  console.log("Data Layer Scripts loaded");
});

// Function to check if the current page is the Where to Buy page
function isWhereToBuyPage() {
  return window.location.href.includes("where-to-buy");
}

function setupSTPTAfterLocationsUpdate() {
  // Backup the original function
  // const originalSTPT_AFTER_LOCATIONS_UPDATE = window.STPT_AFTER_LOCATIONS_UPDATE;
  const targetMarkets = [
    "Kansas City, MO",
    "Cincinnati, OH",
    "Pittsburgh, PA",
    "Boston, MA",
    "Providence, RI",
    "Miami, FL",
    "Tampa, FL",
    "Columbus, OH",
    "Raleigh, NC",
    "Washington, DC",
    "St. Louis, MO",
    "Atlanta, GA",
    "Austin, TX",
    "Indianapolis, IN",
    "Omaha, NE",
    "Philadelphia, PA",
    "Nashville, TN",
    "Grand Rapids, MI",
    "Toronto, ON",
    "Calgary, AB",
    "Montreal, QC",
    "Salt Lake City, UT",
    "Knoxville, TN",
    "Chicago, IL",
    "Vancouver, BC",
    "Denver, CO",
    "Minneapolis, MN",
    "Brooklyn, OH", // Note: Proxy for Cleveland
    "Allen Park, MI", // Note: Proxy for Detroit
    "Brooklyn, NY", // Note: Proxy for New York
  ];

  // Create a new function that wraps the original functionality with additional logic
  window.STPT_AFTER_LOCATIONS_UPDATE = function () {
    // Call the original function to ensure its functionality is preserved
    //originalSTPT_AFTER_LOCATIONS_UPDATE();

    // Find the DOM element that contains the location information
    const locationsContainer = document.querySelector(
      "#storepoint-results-container"
    );
    if (locationsContainer) {
      const locationsAddresses = locationsContainer.querySelectorAll(
        ".storepoint-address"
      );
      const targetDistance = 50; // Proxy for the distance to the target market

      // Check if any of the location addresses contain a value within the target markets array
      // Label the outer loop to reference it for breaking
      outerLoop: for (let locationAddress of locationsAddresses) {
        let locationDistance = locationAddress.closest(".storepoint-location").querySelector(".storepoint-distance").textContent;
        locationDistance = parseInt(locationDistance.replace(" miles", ""));
        for (let targetMarket of targetMarkets) {
          if (locationAddress.textContent.includes(targetMarket) && locationDistance <= targetDistance) {
            console.log("Target market found: " + targetMarket);
            console.log("Location: " + locationAddress.textContent);
            console.log("Distance: " + locationDistance + " miles");
            // Push an event to the dataLayer named WhereToBuy_TargetMarketFound
            dataLayer.push({
              event: "WhereToBuyTargetMarketFound",
              label: targetMarket,
            });
            break outerLoop; // Break out of both loops
          }
        }
      }
    }
  };
}

// Function to handle logo clicks on the Where to Buy page
function handleLogoClickOnWhereToBuyPage() {
  const logoList = document.querySelector(".logo-list--inner");
  if (logoList) {
    const logos = logoList.querySelectorAll(".logo-list--logo");
    logos.forEach((logo) => {
      logo.addEventListener("click", function (event) {
        event.preventDefault();
        const url = logo.getAttribute("href");
        const label = logo.getAttribute("aria-label");

        console.log(label + " logo clicked");

        // Push an event to the dataLayer named WhereToBuyLogoClick
        dataLayer.push({
          event: "WhereToBuyLogoClick",
          label: label,
          url: url,
        });

        // Navigate to the URL in a different tab
        window.open(url, "_blank").focus();
      });
    });
  }
}
